import styled from 'styled-components';
import { Space } from 'antd';
import { getSize, getColor } from '@lib/common';
import { MathEnabledTextComponent, RichTextEditor, PrimaryButton, SecondaryButton } from '@lib/common';
import { useDescriptionCollapse } from '../hooks/use-description-collapse.hook'; // Styles

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWrapper = styled.div.withConfig({
  displayName: "card-descriptioncomponent__StyledWrapper",
  componentId: "sc-1gu9jat-0"
})(["margin-top:", ";", ""], getSize('padding8'), function (_ref) {
  var $isEmpty = _ref.$isEmpty;
  return $isEmpty && "\n      display: none;\n    ";
});
export var DescriptionPreviewWrapper = styled.div.withConfig({
  displayName: "card-descriptioncomponent__DescriptionPreviewWrapper",
  componentId: "sc-1gu9jat-1"
})(["position:relative;cursor:", ";width:100%;overflow:hidden;word-wrap:break-word;overflow-wrap:break-word;white-space:", ";max-height:", ";transition:max-height 350ms ease-in-out;img{max-width:100%;height:auto;}@media (prefers-reduced-motion:reduce){transition:none;}"], function (_ref2) {
  var $readonly = _ref2.$readonly;
  return $readonly ? 'default' : 'text';
}, function (_ref3) {
  var $preserveLineBreaks = _ref3.$preserveLineBreaks;
  return $preserveLineBreaks ? 'pre-wrap' : 'normal';
}, function (_ref4) {
  var $maxHeight = _ref4.$maxHeight;
  return $maxHeight ? "".concat($maxHeight, "px") : 'none';
});
var StyledDescriptionContent = styled(MathEnabledTextComponent).withConfig({
  displayName: "card-descriptioncomponent__StyledDescriptionContent",
  componentId: "sc-1gu9jat-2"
})(["p{margin:0;}", ""], function (_ref5) {
  var $reserveToggleSpace = _ref5.$reserveToggleSpace;
  return $reserveToggleSpace && "\n      p:last-child::after {\n        content: '';\n        display: inline-block;\n        width: 96px;\n        height: 1px;\n      }\n    ";
});
var StyledExpandCollapseButton = styled.button.withConfig({
  displayName: "card-descriptioncomponent__StyledExpandCollapseButton",
  componentId: "sc-1gu9jat-3"
})(["position:absolute;right:0;bottom:0;z-index:1;padding:0 0 0 ", ";background:linear-gradient( to right,transparent,", " ", " );border:none;color:", ";font-size:", ";font-weight:600;cursor:pointer;&:hover{opacity:0.8;}"], getSize('padding24'), getColor('fillBgSub'), getSize('padding24'), getColor('fillIntActive'), getSize('typo14'));
export var StyledGroupButton = styled(Space).withConfig({
  displayName: "card-descriptioncomponent__StyledGroupButton",
  componentId: "sc-1gu9jat-4"
})(["display:flex;justify-content:flex-end;margin-top:", ";"], getSize('padding16'));
export var DescriptionEditorWrapper = styled.div.withConfig({
  displayName: "card-descriptioncomponent__DescriptionEditorWrapper",
  componentId: "sc-1gu9jat-5"
})(["width:100%;overflow:visible;"]); // Component

export var CardDescription = function CardDescription(_ref6) {
  var description = _ref6.description,
      _ref6$preserveLineBre = _ref6.preserveLineBreaks,
      preserveLineBreaks = _ref6$preserveLineBre === void 0 ? false : _ref6$preserveLineBre,
      _ref6$isEditing = _ref6.isEditing,
      isEditing = _ref6$isEditing === void 0 ? false : _ref6$isEditing,
      _ref6$isReadonly = _ref6.isReadonly,
      isReadonly = _ref6$isReadonly === void 0 ? false : _ref6$isReadonly,
      placeholder = _ref6.placeholder,
      onChange = _ref6.onChange,
      onSave = _ref6.onSave,
      onCancel = _ref6.onCancel,
      _ref6$saveLabel = _ref6.saveLabel,
      saveLabel = _ref6$saveLabel === void 0 ? 'Save' : _ref6$saveLabel,
      _ref6$cancelLabel = _ref6.cancelLabel,
      cancelLabel = _ref6$cancelLabel === void 0 ? 'Cancel' : _ref6$cancelLabel,
      editorLabels = _ref6.editorLabels,
      onAddImage = _ref6.onAddImage,
      onAddAudio = _ref6.onAddAudio,
      richTextEditorRef = _ref6.richTextEditorRef,
      _ref6$hideButtons = _ref6.hideButtons,
      hideButtons = _ref6$hideButtons === void 0 ? false : _ref6$hideButtons,
      _ref6$isShowingExtend = _ref6.isShowingExtendOrCollapse,
      isShowingExtendOrCollapse = _ref6$isShowingExtend === void 0 ? false : _ref6$isShowingExtend,
      _ref6$expandLabel = _ref6.expandLabel,
      expandLabel = _ref6$expandLabel === void 0 ? 'Show more' : _ref6$expandLabel,
      _ref6$collapseLabel = _ref6.collapseLabel,
      collapseLabel = _ref6$collapseLabel === void 0 ? 'Show less' : _ref6$collapseLabel;

  var _useDescriptionCollap = useDescriptionCollapse({
    description: description,
    enabled: isShowingExtendOrCollapse && !isEditing
  }),
      contentRef = _useDescriptionCollap.contentRef,
      collapsedHeight = _useDescriptionCollap.collapsedHeight,
      contentHeight = _useDescriptionCollap.contentHeight,
      isCollapsible = _useDescriptionCollap.isCollapsible,
      isExpanded = _useDescriptionCollap.isExpanded,
      isOverflowing = _useDescriptionCollap.isOverflowing,
      toggleExpanded = _useDescriptionCollap.toggleExpanded;

  var showCollapseControl = isCollapsible && isOverflowing;
  var maxHeight = showCollapseControl ? isExpanded ? contentHeight : collapsedHeight : undefined;

  if (isEditing) {
    return /*#__PURE__*/_jsx(StyledWrapper, {
      children: /*#__PURE__*/_jsxs(DescriptionEditorWrapper, {
        children: [/*#__PURE__*/_jsx(RichTextEditor, {
          ref: richTextEditorRef,
          placeholder: placeholder,
          content: description,
          editorLabels: editorLabels,
          addImage: onAddImage,
          addAudio: onAddAudio,
          onChange: onChange
        }), !hideButtons && /*#__PURE__*/_jsxs(StyledGroupButton, {
          children: [/*#__PURE__*/_jsx(SecondaryButton, {
            onClick: onCancel,
            children: cancelLabel
          }), /*#__PURE__*/_jsx(PrimaryButton, {
            onClick: onSave,
            children: saveLabel
          })]
        })]
      })
    });
  }

  return /*#__PURE__*/_jsx(StyledWrapper, {
    $isEmpty: !description,
    children: /*#__PURE__*/_jsxs(DescriptionPreviewWrapper, {
      $readonly: isReadonly,
      $preserveLineBreaks: preserveLineBreaks,
      $maxHeight: maxHeight,
      children: [/*#__PURE__*/_jsx(StyledDescriptionContent, {
        ref: contentRef,
        value: description,
        $reserveToggleSpace: showCollapseControl && isExpanded
      }), showCollapseControl && /*#__PURE__*/_jsx(StyledExpandCollapseButton, {
        type: "button",
        "aria-expanded": isExpanded,
        onClick: function onClick(event) {
          event.stopPropagation();
          toggleExpanded();
        },
        children: isExpanded ? collapseLabel : "\u2026 ".concat(expandLabel)
      })]
    })
  });
};